import DOMPurify from "dompurify";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const ChooseUs = (props) => {
  const dynamicClasses = {
    section1: {
      div1: "rounded-2xl transition-all duration-[3s] mt-20 ml-14 pt-20 pl-16 pr-4 h-[65%]",
      imgClas: "w-[20%] h-[20%]",
      h2: "text-3xl text-[#998147]",
      p: "text-sm md:text-xl text-[#312D2D] pt-5",
      br: "",
    },
    section2: {
      div1: "rounded-2xl opacity-70 pt-16 pl-16 transition-all duration-[3s] h-[55%] mt-[7.5rem] md:w-full pr-4",
      imgClas: "w-[20%] h-[20%]",
      h2: "text-3xl text-[#998147]",
      p: "text-sm md:text-xl text-[#312D2D] pt-5",
      br: "hidden lg:flex",
    },
    section3: {
      div1: "rounded-2xl opacity-50 transition-all duration-[3s]  pt-12 pl-16 h-[45%] mt-40 sm:w-[80%] md:w-full pr-4",
      imgClas: "w-[20%] h-[20%]",
      h2: "text-3xl text-[#998147]",
      p: "text-sm md:text-xl text-[#312D2D] pt-5",
      br: "hidden ",
    },
  };
  return (
    <div className="my-4 pt-2 sm:pt-5 md:pt-10 md:pb-4 flex flex-col">
      <div>
        <h1 className="text-lg ml-4 pl-[2.7rem] sm:pl-[4.8rem] md:pl-10 sm:text-2xl md:text-5xl text-[#15363A] font-bold">
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.data.title),
            }}
          />
        </h1>
      </div>
      <div className="hidden md:flex md:flex-row h-[45rem] -mt-4 w-full gap-10">
        <Swiper
          spaceBetween={20}
          slidesPerView={3}
          modules={[Autoplay]}
          loop={true}
          speed={3000}
          autoplay={{ delay: 3000 }}
        >
          <SwiperSlide>
            {({ isActive, isPrev, isNext }) => (
              <div
                id="cardSection"
                className={
                  isActive || isPrev
                    ? dynamicClasses.section1.div1
                    : isNext
                      ? dynamicClasses.section2.div1
                      : dynamicClasses.section3.div1
                }
              >
                <div>
                  <img
                    className={
                      isActive || isPrev
                        ? dynamicClasses.section1.imgClas
                        : isNext
                          ? dynamicClasses.section2.imgClas
                          : dynamicClasses.section3.imgClas
                    }
                    src={props.data.cards[0].icon}
                    alt="no img"
                  />
                </div>
                <h2
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.h2
                      : isNext
                        ? dynamicClasses.section2.h2
                        : dynamicClasses.section3.h2
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[0].title),
                    }}
                  />
                </h2>
                <h3
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.p
                      : isNext
                        ? dynamicClasses.section2.p
                        : dynamicClasses.section3.p
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[0].desc),
                    }}
                  />
                </h3>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive, isPrev, isNext }) => (
              <div
                id="cardSection"
                className={
                  isActive || isPrev
                    ? dynamicClasses.section1.div1
                    : isNext
                      ? dynamicClasses.section2.div1
                      : dynamicClasses.section3.div1
                }
              >
                <div>
                  <img
                    className={
                      isActive || isPrev
                        ? dynamicClasses.section1.imgClas
                        : isNext
                          ? dynamicClasses.section2.imgClas
                          : dynamicClasses.section3.imgClas
                    }
                    src={props.data.cards[1].icon}
                    alt="no img"
                  />
                </div>
                <h2
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.h2
                      : isNext
                        ? dynamicClasses.section2.h2
                        : dynamicClasses.section3.h2
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[1].title),
                    }}
                  />
                </h2>
                <h3
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.p
                      : isNext
                        ? dynamicClasses.section2.p
                        : dynamicClasses.section3.p
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[1].desc),
                    }}
                  />
                </h3>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive, isPrev, isNext }) => (
              <div
                id="cardSection"
                className={
                  isActive || isPrev
                    ? dynamicClasses.section1.div1
                    : isNext
                      ? dynamicClasses.section2.div1
                      : dynamicClasses.section3.div1
                }
              >
                <div>
                  <img
                    className={
                      isActive || isPrev
                        ? dynamicClasses.section1.imgClas
                        : isNext
                          ? dynamicClasses.section2.imgClas
                          : dynamicClasses.section3.imgClas
                    }
                    src={props.data.cards[2].icon}
                    alt="no img"
                  />
                </div>
                <h2
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.h2
                      : isNext
                        ? dynamicClasses.section2.h2
                        : dynamicClasses.section3.h2
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[2].title),
                    }}
                  />
                </h2>
                <h3
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.p
                      : isNext
                        ? dynamicClasses.section2.p
                        : dynamicClasses.section3.p
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[2].desc),
                    }}
                  />
                </h3>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive, isPrev, isNext }) => (
              <div
                id="cardSection"
                className={
                  isActive || isPrev
                    ? dynamicClasses.section1.div1
                    : isNext
                      ? dynamicClasses.section2.div1
                      : dynamicClasses.section3.div1
                }
              >
                <div>
                  <img
                    className={
                      isActive || isPrev
                        ? dynamicClasses.section1.imgClas
                        : isNext
                          ? dynamicClasses.section2.imgClas
                          : dynamicClasses.section3.imgClas
                    }
                    src={props.data.cards[0].icon}
                    alt="no img"
                  />
                </div>
                <h2
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.h2
                      : isNext
                        ? dynamicClasses.section2.h2
                        : dynamicClasses.section3.h2
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[0].title),
                    }}
                  />
                </h2>
                <h3
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.p
                      : isNext
                        ? dynamicClasses.section2.p
                        : dynamicClasses.section3.p
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[0].desc),
                    }}
                  />
                </h3>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive, isPrev, isNext }) => (
              <div
                id="cardSection"
                className={
                  isActive || isPrev
                    ? dynamicClasses.section1.div1
                    : isNext
                      ? dynamicClasses.section2.div1
                      : dynamicClasses.section3.div1
                }
              >
                <div>
                  <img
                    className={
                      isActive || isPrev
                        ? dynamicClasses.section1.imgClas
                        : isNext
                          ? dynamicClasses.section2.imgClas
                          : dynamicClasses.section3.imgClas
                    }
                    src={props.data.cards[1].icon}
                    alt="no img"
                  />
                </div>
                <h2
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.h2
                      : isNext
                        ? dynamicClasses.section2.h2
                        : dynamicClasses.section3.h2
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[1].title),
                    }}
                  />
                </h2>
                <h3
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.p
                      : isNext
                        ? dynamicClasses.section2.p
                        : dynamicClasses.section3.p
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[1].desc),
                    }}
                  />
                </h3>
              </div>
            )}
          </SwiperSlide>
          <SwiperSlide>
            {({ isActive, isPrev, isNext }) => (
              <div
                id="cardSection"
                className={
                  isActive || isPrev
                    ? dynamicClasses.section1.div1
                    : isNext
                      ? dynamicClasses.section2.div1
                      : dynamicClasses.section3.div1
                }
              >
                <div>
                  <img
                    className={
                      isActive || isPrev
                        ? dynamicClasses.section1.imgClas
                        : isNext
                          ? dynamicClasses.section2.imgClas
                          : dynamicClasses.section3.imgClas
                    }
                    src={props.data.cards[2].icon}
                    alt="no img"
                  />
                </div>
                <h2
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.h2
                      : isNext
                        ? dynamicClasses.section2.h2
                        : dynamicClasses.section3.h2
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[2].title),
                    }}
                  />
                </h2>
                <h3
                  className={
                    isActive || isPrev
                      ? dynamicClasses.section1.p
                      : isNext
                        ? dynamicClasses.section2.p
                        : dynamicClasses.section3.p
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(props.data.cards[2].desc),
                    }}
                  />
                </h3>
              </div>
            )}
          </SwiperSlide>
        </Swiper>
      </div>
      {/* for mobile */}
      <div className="block md:hidden sm:h-[21.5rem] pt-6 w-full px-5 sm:pr-0">
        <Swiper
          spaceBetween={5}
          slidesPerView={1}
          loop={true}
          centeredSlides={true}
          speed={800}
          autoplay={{ delay: 3000 }}
          modules={[Autoplay]}
        >
          <SwiperSlide key={"s1"}>
            <div className="shadow-inner rounded-2xl border-2 pt-10 sm:pt-16 pl-9 sm:pl-[4.4rem] h-[15rem] sm:h-[20rem] w-[100%] sm:w-[92%] pr-4">
              <div>
                <img
                  className="sm:w-[10%] w-[14%] sm:h-[10%] h-[14%]"
                  src={props.data.cards[0].icon}
                  alt="no img"
                />
              </div>
              <h2 className="text-lg sm:text-2xl text-[#998147]">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.cards[0].title),
                  }}
                />
              </h2>
              <h3 className="text-xs sm:text-sm md:text-xl text-[#312D2D] pt-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.cards[0].desc),
                  }}
                />
              </h3>
            </div>
          </SwiperSlide>
          <SwiperSlide key={"s2"}>
            <div className="shadow-inner rounded-2xl border-2 pt-10 sm:pt-16 pl-9 sm:pl-[4.4rem] h-[15rem] sm:h-[20rem] w-[100%] sm:w-[92%] pr-4">
              <div>
                <img
                  className="sm:w-[10%] w-[14%] sm:h-[10%] h-[14%]"
                  src={props.data.cards[1].icon}
                  alt="no img"
                />
              </div>
              <h2 className="text-lg sm:text-2xl text-[#998147]">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.cards[1].title),
                  }}
                />
              </h2>
              <h3 className="text-xs sm:text-sm md:text-xl text-[#312D2D] pt-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.cards[1].desc),
                  }}
                />
              </h3>
            </div>
          </SwiperSlide>
          <SwiperSlide key={"s3"}>
            <div className="shadow-inner rounded-2xl border-2 pt-10 sm:pt-16 pl-9 sm:pl-[4.4rem] h-[15rem] sm:h-[20rem] w-[100%] sm:w-[92%] pr-4">
              <div>
                <img
                  className="sm:w-[10%] w-[14%] sm:h-[10%] h-[14%]"
                  src={props.data.cards[2].icon}
                  alt="no img"
                />
              </div>
              <h2 className="text-lg sm:text-2xl text-[#998147]">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.cards[2].title),
                  }}
                />
              </h2>
              <h3 className="text-xs sm:text-sm text-[#312D2D] pt-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(props.data.cards[2].desc),
                  }}
                />
              </h3>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      {/*  */}
    </div>
  );
};

export default ChooseUs;
